import React from 'react'
import { Grid, Typography } from '@mui/material'
import useStyles from './styles'
import LocalGasStationIcon from '@mui/icons-material/LocalGasStation';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemText from '@mui/material/ListItemText';
import Avatar from '@mui/material/Avatar';
import Divider from '@mui/material/Divider';
import MoneyIcon from '@mui/icons-material/Money';
import DiscountIcon from '@mui/icons-material/Discount';
import EventIcon from '@mui/icons-material/Event';
import QrCodeScannerIcon from '@mui/icons-material/QrCodeScanner';
import PersonIcon from '@mui/icons-material/Person';

function LeftContent(props) {
    const classes = useStyles();

    return (
        <React.Fragment>
            <Grid className={classes.leftGrid}>
                <img src={props.vLocationImage} alt="pido" style={{ width: '100%' , maxHeight : 200}} />
                <List dense={true} style={{ color: '#000' }}>
                    <ListItem
                        secondaryAction={
                            <Typography>
                                {props.iVolumeReceived} {' لیتر '} {props.vFuelInfoTitle}
                            </Typography>
                        }
                    >
                        <ListItemAvatar>
                            <Avatar>
                                <LocalGasStationIcon />
                            </Avatar>
                        </ListItemAvatar>
                        <ListItemText
                            primary="لیتراژ"
                        />
                    </ListItem>
                    <Divider />
                    <ListItem
                        secondaryAction={
                            <Typography>
                                {props.price.iTotalPrice} {' ریال '}
                            </Typography>
                        }
                    >
                        <ListItemAvatar>
                            <Avatar>
                                <MoneyIcon />
                            </Avatar>
                        </ListItemAvatar>
                        <ListItemText
                            primary="مبلغ پرداختی"
                        />
                    </ListItem>
                    <Divider />
                    <ListItem
                        secondaryAction={
                            <Typography>
                                {props.price.iBasePrice} {' ریال '}
                            </Typography>
                        }
                    >
                        <ListItemAvatar>
                            <Avatar>
                                <MoneyIcon />
                            </Avatar>
                        </ListItemAvatar>
                        <ListItemText
                            primary="مبلغ سوخت"
                        />
                    </ListItem>
                    <Divider />
                    <ListItem
                        secondaryAction={
                            <Typography>
                                {props.price.iDiscount} {' ریال '}
                            </Typography>
                        }
                    >
                        <ListItemAvatar>
                            <Avatar>
                                <DiscountIcon />
                            </Avatar>
                        </ListItemAvatar>
                        <ListItemText
                            primary="میزان تخفیف"
                        />
                    </ListItem>
                    <Divider />
                    <ListItem
                        secondaryAction={
                            <Typography>
                                {props.jalaliDateTime}
                            </Typography>
                        }
                    >
                        <ListItemAvatar>
                            <Avatar>
                                <EventIcon />
                            </Avatar>
                        </ListItemAvatar>
                        <ListItemText
                            primary="تاریخ درخواست"
                        />
                    </ListItem>
                    <Divider />
                    <ListItem
                        secondaryAction={
                            <Typography>
                                {props.vRequestCode}
                            </Typography>
                        }
                    >
                        <ListItemAvatar>
                            <Avatar>
                                <QrCodeScannerIcon />
                            </Avatar>
                        </ListItemAvatar>
                        <ListItemText
                            primary="کد درخواست"
                        />
                    </ListItem>
                    <Divider />
                    <ListItem
                        secondaryAction={
                            <Typography>
                                {props.vOperatorName + ' - ' + props.vFuelCarCode}
                            </Typography>
                        }
                    >
                        <ListItemAvatar>
                            <Avatar>
                                <PersonIcon />
                            </Avatar>
                        </ListItemAvatar>
                        <ListItemText
                            primary="نام اپراتور"
                        />
                    </ListItem>
                    <Divider />
                    <ListItem
                        style={{ marginTop: 15, textAlign: 'left' }}
                        secondaryAction={
                            <Typography>
                                {props.vAddress}
                            </Typography>
                        }
                    >
                    </ListItem>
                </List>
            </Grid>
        </React.Fragment >
    )
}

export default LeftContent
